export const MAIN_MARKDOWN_ID = 'main-markdown-render'
